import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import { MerchantService } from 'src/app/core/merchant.service';

@Component({
  selector: 'app-register-success-modal',
  templateUrl: './register-success-modal.component.html',
  styleUrls: ['./register-success-modal.component.scss'],
})
export class RegisterSuccessModalComponent implements OnInit {
  tenant: string = '';
  merchant: string = '';
  personType: string = '';

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private merchantService: MerchantService,

    private readonly modalService: BoobleModalService
  ) {}

  ngOnInit(): void {
    this.route.firstChild.paramMap.subscribe((params) => {
      const tenant = params.get('tenant');
      const personType = params.get('personType');

      if (tenant) this.tenant = params.get('tenant');
      if (personType) this.personType = params.get('personType');
    });

    this.merchant = this.merchantService.getLoginMerchant(this.tenant);
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  goToLogin() {
    this.closeModal();
    this.router.navigateByUrl(`${this.tenant}/login?m=${this.merchant}`);
  }
}
